const CHANGE_SUMMARY_FILTER = 'CHANGE_SUMMARY_FILTER';

const changeSummaryFiltersAction = (selected) => (dispatch) => {
    dispatch({
        type: CHANGE_SUMMARY_FILTER,
        selected
    });
};

export default changeSummaryFiltersAction;
